import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './locales/de.json';
import en from './locales/en.json';

const DEFAULT_LOCALE = (import.meta.env.VITE_DEFAULT_LOCALE as string) || 'de';

void i18n.use(initReactI18next).init({
  resources: {
    de: { translation: de },
    en: { translation: en },
  },
  lng: DEFAULT_LOCALE,
  fallbackLng: 'de',
  interpolation: { escapeValue: false },
});

export default i18n;
